import { IItemResponse, IItemResponseBase } from '@gcl/react-core';
import { IApiBaseProps } from '@common/api.models';
import { apiServerGet, apiServerPost, apiServerPut } from '@common/axios.services';
import { envConfigs } from '@config/envConfigs';
import {
  ICancelProjectMasterScheduleRequest,
  ICreateT1Request,
  IMasterScheduleDetail,
  IUpdateT1Request,
  ILockProjectMasterScheduleRequest,
} from './masterScheduleDetail.models';

export const apiRoutes = {
  createMasterSchedule: '/MasterSchedules',
  updateMasterSchedule: '/MasterSchedules',
  getMasterScheduleDetail: '/MasterSchedules',
  cancel: (id: number) => `/MasterSchedules/${id}/Cancel`,
  uncancel: (id: number) => `/MasterSchedules/${id}/Uncancel`,
  lock: (id: number) => `/MasterSchedules/${id}/Lock`,
  unlock: (id: number) => `/MasterSchedules/${id}/Unlock`,
};
export const createMasterScheduleAsync = async (
  request: ICreateT1Request,
): Promise<IItemResponseBase<IMasterScheduleDetail>> => {
  const result = await apiServerPost<IItemResponseBase<IMasterScheduleDetail>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.createMasterSchedule}`,
    request,
  );
  return result.data;
};

export const updateMasterScheduleAsync = async (props: {
  id: number;
  body: IUpdateT1Request;
}): Promise<IItemResponseBase<IMasterScheduleDetail>> => {
  const result = await apiServerPut<IItemResponseBase<IMasterScheduleDetail>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.updateMasterSchedule}/${props.id}`,
    props.body,
  );
  return result.data;
};

export const getMasterScheduleDetailAsync = async (
  id: number,
  props: IApiBaseProps,
): Promise<IItemResponseBase<IMasterScheduleDetail>> => {
  const result = await apiServerGet<IItemResponseBase<IMasterScheduleDetail>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getMasterScheduleDetail}/${id}`,
    {
      params: {
        ...props,
      },
    },
  );
  return result.data;
};

export const cancelMasterScheduleAsync = async (
  request: ICancelProjectMasterScheduleRequest,
): Promise<IItemResponse<IMasterScheduleDetail>> => {
  const result = await apiServerPut<IItemResponse<IMasterScheduleDetail>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.cancel(request.id)}`,
    request,
  );
  return result.data;
};

export const uncancelMasterScheduleAsync = async (
  request: ICancelProjectMasterScheduleRequest,
): Promise<IItemResponse<IMasterScheduleDetail>> => {
  const result = await apiServerPut<IItemResponse<IMasterScheduleDetail>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.uncancel(request.id)}`,
    request,
  );
  return result.data;
};

export const lockMasterScheduleAsync = async (
  request: ILockProjectMasterScheduleRequest,
): Promise<IItemResponse<IMasterScheduleDetail>> => {
  const result = await apiServerPut<IItemResponse<IMasterScheduleDetail>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.lock(request.id)}`,
    request,
  );
  return result.data;
};

export const unlockMasterScheduleAsync = async (
  request: ILockProjectMasterScheduleRequest,
): Promise<IItemResponse<IMasterScheduleDetail>> => {
  const result = await apiServerPut<IItemResponse<IMasterScheduleDetail>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.unlock(request.id)}`,
    request,
  );
  return result.data;
};
